import { useEffect } from "react";

export function useSEO(title, description, jsonLd) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (meta) meta.setAttribute("content", description);
    }
    let tag;
    if (jsonLd) {
      tag = document.createElement("script");
      tag.type = "application/ld+json";
      tag.id = "seo-jsonld";
      tag.text = JSON.stringify(jsonLd);
      document.head.appendChild(tag);
    }
    return () => {
      const el = document.getElementById("seo-jsonld");
      if (el) el.remove();
    };
  }, [title, description, JSON.stringify(jsonLd)]);
}
